import React, {Component, useRef, useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, OverlayTrigger, Tooltip} from 'react-bootstrap';
// tslint:disable-next-line:no-import-side-effect
import './TooltipButton.scss';

interface Props {
  isFein?: boolean;
}
interface State {
  show: boolean;
}

class TooltipButton extends Component<Props, State> {
  state: State = {
    show: false
  };

  getTooltipContent() {
    if (this.props.isFein) {
      return (
        <Tooltip id='{`tooltip-right`}'>
          Nine digit Federal Employer Identification Number assigned by the IRS.
        </Tooltip>
      );
    } else {
      return (
        // tslint:disable-next-line:jsx-wrap-multiline
        <Tooltip id='{`tooltip-right`}' className='custom-tooltip'>
          <img
            src='/img/Invoice-Policy-Number.png'
            alt='Where to find policy number'
          />
        </Tooltip>
      );
    }
  }

  render() {
    return (
      <OverlayTrigger
        trigger={['hover', 'focus']}
        placement='right'
        overlay={this.getTooltipContent()}
      >
        <Button
          onClick={() => this.setState({show: !this.state.show})}
          style={{
            marginLeft: '12px',
            border: 'none',
            backgroundColor: 'transparent',
            padding: '0',
            display: 'flex'
          }}
        >
          <FontAwesomeIcon
            icon='question-circle'
            color='#1313b7'
            className='fa-lg'
          />
        </Button>
      </OverlayTrigger>
    );
  }
}

export default TooltipButton;
